import { render, staticRenderFns } from "./CmgRadioButton.vue?vue&type=template&id=023f4234&scoped=true&lang=pug"
import script from "./cmg-radio-button.ts?vue&type=script&lang=ts&external"
export * from "./cmg-radio-button.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRadioButton.vue?vue&type=style&index=0&id=023f4234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f4234",
  null
  
)

export default component.exports